import { Edit } from '@mui/icons-material';
import { Button } from '@mui/material';
import { type Role } from 'components/Permission/permission.types';
import { navigationMap } from 'components/Route/navigationMap';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'store/hook';
import {
  hasAccessToMultipleCustomers,
  isExternalRole,
} from 'utils/validators/role.validation';

export const CustomerInfo = ({ role }: { role: Role }) => {
  const navigateTo = useNavigate();

  const { customer: customerExternal } = useAppSelector(
    (state) => state.authReducer
  );

  const { customer: customerInternal } = useAppSelector(
    (state) => state.persistedReducer
  );

  const customer = isExternalRole(role) ? customerExternal : customerInternal;

  const canEditCustomer = useMemo(() => {
    if (role) {
      const temp = hasAccessToMultipleCustomers(role);
      return temp;
    }
    return false;
  }, [role]);

  const handleCustomerEditClick = () => {
    if (canEditCustomer) {
      navigateTo(navigationMap.customerSelectionView.path, {
        replace: true,
      });
    }
  };
  return (
    <Button
      endIcon={canEditCustomer ? <Edit /> : null}
      onClick={handleCustomerEditClick}
      disabled={!canEditCustomer}
      sx={{
        position: 'relative',
        color: 'white',
        background: 'rgba(255, 255, 255, 0.05)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '10px',
        height: '38px',
        cursor: 'pointer',
        textTransform: 'none',
        fontWeight: 500,
        fontSize: '0.9rem',
        backdropFilter: 'blur(10px)',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.4)',
          transform: 'translateY(-1px)',
        },
        '&:disabled': {
          color: 'white',
          border: 'none',
        },
      }}
    >
      {customer?.name}
    </Button>
  );
};
